import React from 'react';

import {Row, Col, Button, Spin, Icon} from 'antd';

import './OrderInformationPanel.scss';
import FieldValueVerticalCell from 'components/general/FieldValueVerticalCell';

import withUseIntl from "components/withUseIntl";

class OrderBeneficiaryDetailsPanel extends React.Component {
    render() {
      const intl = this.props.useIntl;  
      return (
        <div>
          <Row gutter={16}>
            <Col sm={12}>
              <FieldValueVerticalCell className="bp-table-cell" title={intl.formatMessage({id: "app.panel.orderbeneficiarydetailspanel.nameofbeneficiary"})} value={this.props.order.beneficiary.fullName} />
            </Col>
            <Col sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title={intl.formatMessage({id: "app.panel.orderbeneficiarydetailspanel.beneficiarycountry"})}
                value={this.props.order.beneficiary.beneficiaryCountryName} />
            </Col>
          </Row>
          <Row gutter={16} className="bp-margin-top-smallest">
            <Col sm={12}>
              <FieldValueVerticalCell className="bp-table-cell" title={intl.formatMessage({id: "app.panel.orderbeneficiarydetailspanel.bankaccount"})} value={this.props.order.beneficiary.accountNumber} />
            </Col>
            <Col sm={12}>
              <FieldValueVerticalCell className="bp-table-cell" title={intl.formatMessage({id: "app.panel.orderbeneficiarydetailspanel.bankname"})} value={this.props.order.beneficiary.bankName} />
            </Col>
          </Row>

            {this.buildIntermediaryBankInfo()}
        </div>
      )
    }

    buildIntermediaryBankInfo() {
        const intl = this.props.useIntl;
        let customer = this.props.customer;
        if(customer.accountType == "CORPORATE" && customer.corporateAccountDetails) {
            let intermediaryBankAccount = customer.corporateAccountDetails.intermediaryBankAccount;
            let intermediaryBankName = customer.corporateAccountDetails.intermediaryBankName;
            return (
                <Row gutter={16} className="bp-margin-top-smallest">
                    {intermediaryBankAccount && <Col sm={12}>
                        <FieldValueVerticalCell className="bp-table-cell"
                                                title={intl.formatMessage({id: "app.panel.orderbeneficiarydetailspanel.partnerbankaccount"})}
                                                value={intermediaryBankAccount}/>
                    </Col>}
                    {intermediaryBankName && <Col sm={12}>
                        <FieldValueVerticalCell className="bp-table-cell"
                                                title={intl.formatMessage({id: "app.panel.orderbeneficiarydetailspanel.partnerbankname"})}
                                                value={intermediaryBankName}/>
                    </Col>}
                </Row>
            )
        }
        return null;
    }
}
  
  export default withUseIntl(OrderBeneficiaryDetailsPanel);